export const colors = {
  brandColor: "#8218FF",
};
